import React, {useCallback, useEffect, useState} from 'react';
import {apiHooks} from "../../../hooks/useFetch";
import {isNullOrUndefined, isSuccessResponse, toastHelper} from "../../../shared";
import { Api, AppSettings } from '../../../settings';
import SignIn from "./SignIn";

export const SignInProvider = (props) => {
  const {execute: createSignInRequest, error} = apiHooks.usePost(Api.signIn);
  const [email, setEmail] = useState(null);

  const onSubmit = useCallback(async (values) => {
    const request = {
      "username": values.email,
      "app": AppSettings.appKey
    };

    const response = await createSignInRequest({data: request});

    if (isSuccessResponse(response)) {
      setEmail(values.email);
      return;
    }

    toastHelper.showGenericErrorMessage();
  }, [setEmail, createSignInRequest]);

  useEffect(() => {
    if (error) {
      toastHelper.showGenericErrorMessage();
    }
  }, [error]);

  const resetSignIn = useCallback(() => {
    setEmail(null);
  }, [setEmail]);

  return (
    <SignIn
      onSubmit={onSubmit}
      isSubmitting={!isNullOrUndefined(email)}
      onResetSignIn={resetSignIn}
      email={email}/>
  );
};

SignInProvider.propTypes = {};

SignInProvider.defaultProps = {};

export default SignInProvider;
